// ABOUTME: Displays and manages production targets for the selected material.
// ABOUTME: Uses plant metadata to format target periods in local time.
import {dataTestId} from '@hconnect/uikit'
import {CardBox, Loader} from '@hconnect/uikit/src/lib2'
import {Stack} from '@mui/material'
import React from 'react'

import {usePermission} from '../../../../permissions'

import {StrengthTargets} from './StrengthTargets'

import {useSettingsPlant} from '@settings/modules/common/hooks/useSettingsPlant'

export const MaterialSettingsTargetsTab: React.FC = () => {
  const canChangeTargets = usePermission('ASSIGN_MASTER_DATA_PROCESS')
  const {timezone} = useSettingsPlant()

  if (!timezone) {
    return (
      <CardBox>
        <Loader />
      </CardBox>
    )
  }

  return (
    <Stack spacing={3} {...dataTestId('cement_targets')}>
      <StrengthTargets isReadOnly={!canChangeTargets} timezone={timezone} />
    </Stack>
  )
}
